const state = {
  currentSchema: {},
  currentWidgetData: {},
  widgetDisclaimers: [],
  schemaValidations: {}
};
export default state;